import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { useCallback, useContext, useEffect, useState } from "react";
import { MdHighlightOff } from "react-icons/md";
import { getAllOrganizationsSecond } from "api/graphQL_organizations";
import { getClientsSecond, getClientTreasuryTotal } from "api/graphQL_clients";
import { Select as AntSelect } from "antd";
import DivLoader from "components/divloader/DivLoader";
import { FiUploadCloud, FiXCircle } from "react-icons/fi";
import toast from "react-hot-toast";
import { useDropzone } from "react-dropzone";
import { ClientContext } from "ClientProvider";
import { createBatchPayout } from "api/graphQL_fiat";
import Batch from "../../../../../assets/csv/FiatBatch.csv";
import BloxBatch from "../../../../../assets/csv/BloxFiatBatch.csv";
import CapaBatch from "../../../../../assets/csv/CapaFiatBatch.csv";
import OrionXBatch from "../../../../../assets/csv/OrionXFiatBatch.csv";
import Papa from "papaparse";
import { getAllGatewaysByClient, getGatewayBalance } from "api/graphQL_gateways";
import { getCurrencySymbol, currencyCodes } from "utils/currencyList";
import axios from "axios";

interface DisplayData {
  gateway: any; currency: any;
  total_amount: { totalAmount: any; totalPercentageFee: any; totalFixedFee: any; totalFees: any } | null;
  gateway_id: any; client_id: any; gateway_details: any; gateway_balance: any; client_treasury: any;
}
interface iCreateBatchForm { org_id: string; client_id: string; approval_type: string; batch_file: any; gateway: any; }
export type AllGatewayObj = { name: string; id: string; };

const FileDropzone = ({ label, onFileSelect, onRemoveFile, sampleBatchFile, resetKey }: {
  label: string; onFileSelect: (file: string | null) => void;
  onRemoveFile: any; sampleBatchFile: any; resetKey?: any;
}) => {
  const [fileName, setFileName] = useState("");
  const onDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      const allowedTypes = ["text/csv", "application/vnd.ms-excel"];
      if (allowedTypes.includes(file.type)) {
        setFileName(file.name);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => onFileSelect(reader.result as string);
      } else { toast.error("Only CSV files are allowed."); setFileName(""); onFileSelect(""); }
    }
  }, [onFileSelect]);
  useEffect(() => {
    if (resetKey) { onRemoveFile(true); setFileName(""); onFileSelect(""); }
  }, [resetKey]);
  const removeFile = () => { onRemoveFile(true); setFileName(""); onFileSelect(""); };
  const { getRootProps, getInputProps } = useDropzone({ onDrop, disabled: !sampleBatchFile });

  return (
    <div {...getRootProps()} className={`abf-dropzone${sampleBatchFile ? " abf-dropzone--active" : " abf-dropzone--disabled"}`}>
      <input {...getInputProps()} />
      {fileName ? (
        <div className="abf-dropzone-file">
          <FiUploadCloud size={16} style={{ color:"#16a34a" }} />
          <span className="abf-dropzone-filename">{fileName}</span>
          <button className="abf-dropzone-remove" onClick={(e) => { e.stopPropagation(); removeFile(); }}>
            <FiXCircle size={14} />
          </button>
        </div>
      ) : (
        <div className="abf-dropzone-placeholder">
          <FiUploadCloud size={28} style={{ color: sampleBatchFile ? "#2563eb" : "#cbd5e1", marginBottom:"8px" }} />
          <p className="abf-dropzone-label">{label}</p>
          {!sampleBatchFile && <p className="abf-dropzone-hint">Select a gateway first</p>}
        </div>
      )}
    </div>
  );
};

const AddBatchFile = ({ fetchPayouts }: { fetchPayouts: () => void }) => {
  const rootForm: iCreateBatchForm = { org_id: "", client_id: "", approval_type: "", batch_file: "", gateway: "" };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCloseModal, setIsCloseModal] = useState(false);
  const [page] = useState(1); const [pageSize] = useState(500); const [searchTexts] = useState("");
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [allOrg, setAllOrg] = useState<any[]>([]);
  const [clients, setClients] = useState<any[]>([]);
  const [formValues, setFormValues] = useState<iCreateBatchForm>(rootForm);
  const [formValuesErr, setFormValuesErr] = useState<iCreateBatchForm>(rootForm);
  const [isLoading, setIsLoading] = useState(false);
  const [batchFile, setBatchFile] = useState<string | null>(null);
  const [removeFile, setRemoveFile] = useState(false);
  const { singleRoleData } = useContext(ClientContext);
  const [allGateways, setAllGateways] = useState<AllGatewayObj[]>([]);
  const [sourceCurrency, setSourceCurrency] = useState("");
  const [selectedGateway, setSelectedGateway] = useState("");
  const [displayData, setDisplayData] = useState<DisplayData | null>(null);
  const [isBalanceLoading, setIsBalanceLoading] = useState(false);
  const [lowBalanceError, setLowBalanceError] = useState("");
  const [addDisabled, isAddDisabled] = useState(true);
  const [sampleBatchFile, setSampleBatchFile] = useState<string | null>(null);
  const [smapleBatchName, setSampleBatchName] = useState("");
  const [resetKey, setResetKey] = useState(0);

  const sampleBatch: Record<string, any> = { Blox: BloxBatch, Capa: CapaBatch, Orionx: OrionXBatch };

  const fetchClients = (org_id: any) => {
    if (!org_id) { setClients([]); return; }
    const selectedOrgName = allOrg.find(org => org.id === org_id)?.name || '';
    getClientsSecond({ page, per_page: pageSize, searchTexts: selectedOrgName })
      .then((data) => setClients(data?.[0]?.map((ele: any) => ({ name: ele.name, id: ele.client_id }))));
  };
  const fetchOrganizations = () => {
    getAllOrganizationsSecond(page, pageSize, searchTexts).then((data) => {
      const mapped = data?.[0]?.map((ele: any) => ({ name: ele.name, id: ele.id }));
      setOrganizations(mapped); setAllOrg(mapped);
    });
  };
  const handleClose = () => {
    setFormValues(rootForm); setFormValuesErr(rootForm); setBatchFile("");
    setIsCloseModal(true); setClients([]); setAllGateways([]);
    setSourceCurrency(""); setDisplayData(null); isAddDisabled(true);
    setLowBalanceError(""); setSampleBatchFile(null); setSampleBatchName("");
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  useEffect(() => {
    if (typeof batchFile === "string" && batchFile.trim() !== "") {
      setRemoveFile(false);
      setFormValues((p: any) => ({ ...p, batch_file: batchFile }));
      setFormValuesErr((p: any) => ({ ...p, batch_file: "" }));
      fetchBalance(batchFile);
    }
  }, [batchFile]);

  useEffect(() => {
    if (removeFile) { setFormValues((p: any) => ({ ...p, batch_file: "" })); setDisplayData(null); }
  }, [removeFile]);

  function validateData() {
    let v: any = {};
    if (!formValues?.org_id) v.org_id = "The field is required";
    if (!formValues?.client_id) v.client_id = "The field is required";
    if (!formValues?.gateway) v.gateway = "The field is required";
    if (!formValues?.approval_type) v.approval_type = "The field is required";
    if (!formValues?.batch_file) v.batch_file = "The field is required";
    if (Object.keys(v).length > 0) { setFormValuesErr(v); return false; }
    return true;
  }

  const REQUIRED_HEADERS = ["amount","customer_id","document_number","bank_account","bank_code","account_type","country_code"];
  const validateCSV = (csvDataUri: string) => {
    const base64Data = csvDataUri.replace(/^data:text\/csv;base64,/, '');
    const csvText = atob(base64Data);
    const parsed = Papa.parse<Record<string, string>>(csvText, { header: true, skipEmptyLines: true });
    if (parsed.errors.length > 0) { toast.error("CSV parsing failed, please download sample CSV file"); return false; }
    const actualHeaders = Object.keys(parsed.data[0] || {});
    const missingHeaders = REQUIRED_HEADERS.filter(h => !actualHeaders.includes(h));
    if (missingHeaders.length > 0) { toast.error(`Missing headers: ${missingHeaders.map(h => h.replace(/_/g,' ')).join(", ")}`); return false; }
    return true;
  };

  async function handleSubmit(e: any) {
    e.preventDefault();
    if (!validateData()) return;
    if (!validateCSV(formValues.batch_file)) return;
    setIsLoading(true);
    createBatchPayout({ client_id: formValues.client_id, organization_id: formValues.org_id, type: formValues.approval_type.replace("_",'-'), file: formValues.batch_file, gateway: formValues.gateway })
      .then((data: any) => {
        if (data.message === 'There are no any fiat gateway assigned to client') { toast.error(data.message); }
        else { toast.success(data.message); handleClose(); fetchPayouts(); }
        setIsLoading(false);
      }).catch(() => setIsLoading(false));
  }

  const fetchGateways = (client_id: any) => {
    getAllGatewaysByClient(client_id).then((data) => {
      const filtered = (data ?? []).filter((gw: any) => gw?.payment_method?.filterPaymentMethod?.some((m: any) => m.name === "payout" && m.is_Active === true));
      setAllGateways(filtered.map((item: any) => ({ ...item, id: item.gateway_id })));
    }).catch(console.error);
  };

  const convertAmount = async (amount: any, from: any, to: any) => {
    return axios.get(`https://api.fastforex.io/convert?api_key=629bf7299e-e7215fb94a-s85scd&from=${from}&to=${to}&amount=${amount}`)
      .then(r => r.data.result[to]).catch(() => null);
  };

  const readCSV = async (csvDataUri: string, margin_fee: any) => {
    if (!validateCSV(csvDataUri)) return false;
    const csvText = atob(csvDataUri.replace(/^data:text\/csv;base64,/, ''));
    const { data, errors } = Papa.parse<Record<string, string>>(csvText, { header: true, skipEmptyLines: true });
    if (errors.length > 0) { toast.error("CSV parsing failed"); return false; }
    const pf = parseFloat(margin_fee?.percentageFee || "0"), ff = parseFloat(margin_fee?.fixedFee || "0");
    let totalAmount = 0, totalPercentageFee = 0, totalFixedFee = 0;
    for (const row of data) {
      if (row.amount && (row.currency || row.fiat_currency)) {
        const c = row.currency || row.fiat_currency;
        const converted = await convertAmount(row.amount, c, sourceCurrency);
        const amt = isNaN(parseFloat(converted)) ? 0 : parseFloat(converted);
        totalAmount += amt; totalPercentageFee += amt * (pf / 100); totalFixedFee += ff;
      }
    }
    return { totalAmount, totalPercentageFee, totalFixedFee, totalFees: totalPercentageFee + totalFixedFee };
  };

  const fetchMarginFee = async (client_id: any, gateway_id: any) => {
    return getAllGatewaysByClient(client_id).then((data) => {
      if (!data || !Array.isArray(data)) return null;
      const gw = data.find((g: any) => g.gateway_id === gateway_id);
      if (!gw) return null;
      const cf = gw?.reserved_pricing?.crypto_fees;
      if (!cf || cf.currency_code !== sourceCurrency) { if (cf) toast.error("Crypto fees not defined for " + sourceCurrency); return null; }
      return { percentageFee: cf.percentage_fee, fixedFee: cf.fixed_fee, currency_code: cf.currency_code, authInfo: gw?.auth_info };
    }).catch(() => null);
  };

  const fetchClientTreasury = async (client_id: any) => {
    return getClientTreasuryTotal(client_id, sourceCurrency).then((data) => data[0].total_treasury).catch(() => null);
  };

  const fetchBalance = async (batchFile: any) => {
    setIsBalanceLoading(true); isAddDisabled(true);
    const gd = await fetchMarginFee(formValues.client_id, formValues.gateway);
    if (gd) {
      const total_amount = await readCSV(batchFile, gd);
      if (total_amount) {
        const ct = await fetchClientTreasury(formValues.client_id);
        setDisplayData({ gateway: selectedGateway, currency: sourceCurrency, total_amount: typeof total_amount === "object" ? total_amount : null, gateway_id: formValues.gateway, client_id: formValues.client_id, gateway_details: gd, gateway_balance: null, client_treasury: ct });
        if (parseFloat(ct) > total_amount.totalFees) { isAddDisabled(false); setLowBalanceError(""); }
        else { isAddDisabled(true); setLowBalanceError("Insufficient funds to process the batch. Please contact your representative to refill your account"); }
      } else { setDisplayData(null); }
    } else { setDisplayData(null); }
    setIsBalanceLoading(false);
  };

  const handleFieldChange = (field: string, value: any) => {
    const gw = allGateways.find((g: any) => g.id === value);
    const gw_name = gw ? gw.name : "";
    const gatewayDisplayName =
      singleRoleData?.[0]?.fiat?.value?.show_fiat_payout_gateway_name
        ? gw?.name || ""
        : gw?.id || "";
    const batch = sampleBatch[gw_name as keyof typeof sampleBatch] || null;
    setSampleBatchFile(batch || null); setSampleBatchName(batch ? `${gatewayDisplayName} Batch File` : "");
    setFormValues((p: any) => ({ ...p, [field]: value, batch_file: "" }));
    setFormValuesErr((p: any) => ({ ...p, [field]: "" }));
    setDisplayData(null); setResetKey(prev => prev + 1);
  };


  return (
    <>
      {singleRoleData?.[0]?.fiat?.value?.add_fiat_batch_file && (
        <button className="abf-trigger-btn" onClick={() => { fetchOrganizations(); onOpen(); }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Fiat Batch Payout
        </button>
      )}

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`abf-panel${isOpen && !isCloseModal ? " abf-panel--open" : " abf-panel--close"}`}>
          <div className="abf-glow" />

          <div className="abf-header">
            <div className="abf-header-brand">
              <div className="abf-header-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
              </div>
              <div>
                <h2 className="abf-title">Fiat Batch Payout</h2>
                <p className="abf-sub">Upload and configure a batch payout file</p>
              </div>
            </div>
            <button className="abf-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="abf-body">
            {/* Organization */}
            <div className="abf-field-group">
              <label className="abf-label">Organization <span className="abf-req">*</span></label>
              <AntSelect
                showSearch allowClear placeholder="Select Organization"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="abf-ant-select" style={{ width:"100%" }}
                options={organizations.map((m: any) => ({ ...m, label: m.name, value: m.id }))}
                value={formValues?.org_id || undefined}
                onChange={(e: any) => {
                  setFormValues((p: any) => ({ ...p, org_id: e, client_id: "", gateway: "" }));
                  setFormValuesErr((p: any) => ({ ...p, org_id: "" }));
                  setAllGateways([]); fetchClients(e);
                }}
                notFoundContent="Organization not found"
              />
              {formValuesErr?.org_id && <p className="abf-err">{formValuesErr.org_id}</p>}
            </div>

            {/* Client */}
            <div className="abf-field-group">
              <label className="abf-label">Client <span className="abf-req">*</span></label>
              <AntSelect
                showSearch allowClear placeholder="Select Client"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="abf-ant-select" style={{ width:"100%" }}
                options={clients.map((m: any) => ({ label: m.name, value: m.id }))}
                value={formValues?.client_id || undefined}
                onChange={(e: any) => {
                  setFormValues((p: any) => ({ ...p, client_id: e, gateway: "" }));
                  setFormValuesErr((p: any) => ({ ...p, client_id: "" }));
                  setAllGateways([]);
                  if (formValues.batch_file) { setSampleBatchFile(null); setSampleBatchName(""); setFormValues((p: any) => ({ ...p, batch_file: "" })); setDisplayData(null); setResetKey(prev => prev + 1); }
                  fetchGateways(e);
                }}
                notFoundContent="Client not found"
              />
              {formValuesErr?.client_id && <p className="abf-err">{formValuesErr.client_id}</p>}
            </div>

            {/* Gateway */}
            <div className="abf-field-group">
              <label className="abf-label">Gateway <span className="abf-req">*</span></label>
              <AntSelect
                showSearch allowClear placeholder="Select Gateway"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="abf-ant-select" style={{ width:"100%" }}
                options={allGateways.map((m: any) => ({ ...m, label: singleRoleData?.[0]?.fiat?.value?.show_fiat_payout_gateway_name ? m.name : m.id, value: m.id }))}
                value={formValues?.gateway || undefined}
                onChange={(e: any) => handleFieldChange("gateway", e)}
                onSelect={(_: any, opt: any) => setSelectedGateway(opt.label)}
                notFoundContent="Gateway not found"
              />
              {formValuesErr?.gateway && <p className="abf-err">{formValuesErr.gateway}</p>}
            </div>

            {/* Settlement Currency */}
            <div className="abf-field-group">
              <label className="abf-label">Settlement Currency <span className="abf-req">*</span></label>
              <AntSelect
                showSearch allowClear placeholder="Select Currency"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="abf-ant-select" style={{ width:"100%" }}
                options={currencyCodes.map((c) => { const d = getCurrencySymbol(c); return { value: c, label: `${c}: ${d.title?.toUpperCase()}` }; })}
                value={sourceCurrency || undefined}
                onChange={(e: any) => {
                  setSourceCurrency(e);
                  setFormValuesErr((p: any) => ({ ...p, batch_file: "" }));
                  if (formValues.batch_file) { setFormValues((p: any) => ({ ...p, batch_file: "" })); setDisplayData(null); setResetKey(prev => prev + 1); }
                }}
                notFoundContent="Currency not found"
              />
            </div>

            {/* Approval type */}
            <div className="abf-field-group">
              <label className="abf-label">Approval Type <span className="abf-req">*</span></label>
              <div className="abf-radio-row">
                {[{ val: "auto_approve", label: "Auto Approve" }, { val: "require_approve", label: "Require Approve" }].map((opt) => (
                  <label key={opt.val} className={`abf-radio-card${formValues.approval_type === opt.val ? " abf-radio-card--active" : ""}`}>
                    <input type="radio" name="approval_type" value={opt.val} checked={formValues.approval_type === opt.val}
                      onChange={(e) => { setFormValues((p: any) => ({ ...p, approval_type: e.target.value })); setFormValuesErr((p: any) => ({ ...p, approval_type: "" })); }} />
                    <span>{opt.label}</span>
                  </label>
                ))}
              </div>
              {formValuesErr?.approval_type && <p className="abf-err">{formValuesErr.approval_type}</p>}
            </div>

            {/* CSV Upload */}
            <div className="abf-field-group">
              <div className="abf-csv-label-row">
                <label className="abf-label">CSV File <span className="abf-req">*</span></label>
                {sampleBatchFile && (
                  <a href={sampleBatchFile} download={`${smapleBatchName}.csv`} className="abf-download-link">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    Download {smapleBatchName}
                  </a>
                )}
              </div>
              <FileDropzone label="Upload Batch CSV File" onFileSelect={setBatchFile} onRemoveFile={setRemoveFile} sampleBatchFile={sampleBatchFile} resetKey={resetKey} />
              {formValuesErr?.batch_file && <p className="abf-err">{formValuesErr.batch_file}</p>}
            </div>

            {/* Balance preview */}
            {isBalanceLoading ? (
              <div className="abf-loading"><div className="abf-spinner" /><p className="abf-loading-txt">Calculating batch amounts…</p></div>
            ) : displayData ? (
              <div className="abf-summary">
                <div className="abf-summary-main">
                  <div>
                    <p className="abf-summary-key">Total Batch Amount</p>
                    <p className="abf-summary-val">{displayData?.total_amount?.totalAmount?.toFixed(2)} <span className="abf-summary-currency">{sourceCurrency}</span></p>
                  </div>
                  <div className="abf-summary-fees">
                    <div className="abf-fee-row"><span>Percentage Fee</span><span className="abf-fee-val">{displayData?.total_amount?.totalPercentageFee?.toFixed(2)} {sourceCurrency}</span></div>
                    <div className="abf-fee-row"><span>Fixed Fee</span><span className="abf-fee-val">{displayData?.total_amount?.totalFixedFee?.toFixed(2)} {sourceCurrency}</span></div>
                  </div>
                </div>
                <div className="abf-summary-grid">
                  <div className="abf-summary-card abf-summary-card--green">
                    <p className="abf-summary-card-label">Total Fees</p>
                    <p className="abf-summary-card-val">{displayData?.total_amount?.totalFees?.toFixed(2)} <span>{displayData?.currency}</span></p>
                  </div>
                  <div className="abf-summary-card abf-summary-card--blue">
                    <p className="abf-summary-card-label">Client Treasury</p>
                    <p className="abf-summary-card-val">{parseFloat(displayData?.client_treasury).toFixed(2)} <span>{sourceCurrency}</span></p>
                  </div>
                </div>
                {lowBalanceError && (
                  <div className="abf-error-banner">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                    <span>{lowBalanceError}</span>
                  </div>
                )}
              </div>
            ) : null}
          </div>

          <div className="abf-footer">
            <div className="abf-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              All fields are required to proceed
            </div>
            <div className="abf-footer-btns">
              <button className="abf-btn-cancel" onClick={handleClose}>Cancel</button>
              <button className="abf-btn-submit" onClick={handleSubmit} disabled={isLoading || addDisabled}>
                {isLoading ? <span className="abf-btn-spinner" /> : (
                  <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Add Batch</>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .abf-trigger-btn { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:700; color:#fff; padding:7px 18px; border-radius:10px; border:none; background:linear-gradient(135deg,#1d4ed8,#2563eb); cursor:pointer; box-shadow:0 3px 12px rgba(37,99,235,.28); transition:all .15s; white-space:nowrap; }
        .abf-trigger-btn:hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(37,99,235,.36); }

        .abf-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:560px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
        .abf-panel--open  { transform:translateX(0); }
        .abf-panel--close { transform:translateX(100%); }

        .abf-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#0f2744,#2563eb,#7c3aed,#2563eb,#0f2744); background-size:200% 100%; animation:abfGlow 3s linear infinite; }
        @keyframes abfGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .abf-header { padding:15px 26px; background:linear-gradient(135deg,#0f2744 0%,#1d4ed8 60%,#2563eb 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .abf-header-brand { display:flex; align-items:center; gap:13px; }
        .abf-header-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .abf-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
        .abf-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
        .abf-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
        .abf-close:hover { color:#fff; }

        .abf-body { flex:1; padding:20px 26px; overflow-y:auto; display:flex; flex-direction:column; gap:16px; }
        .abf-body::-webkit-scrollbar { width:4px; }
        .abf-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

        .abf-field-group { display:flex; flex-direction:column; gap:6px; }
        .abf-label { font-size:13px; font-weight:700; color:#0f172a; }
        .abf-req { color:#dc2626; }
        .abf-err { font-size:12px; color:#dc2626; font-weight:500; }
        .abf-ant-select .ant-select-selector { height:44px !important; border:1.5px solid #e2e8f0 !important; border-radius:10px !important; background:#f8fafc !important; font-family:'Plus Jakarta Sans',sans-serif !important; }
        .abf-ant-select .ant-select-selection-search-input { height:42px !important; }
        .abf-ant-select .ant-select-selection-placeholder { line-height:42px !important; color:#cbd5e1 !important; font-size:13px !important; }
        .abf-ant-select .ant-select-selection-item { line-height:42px !important; font-size:13px !important; font-weight:600 !important; }

        .abf-radio-row { display:flex; gap:10px; flex-wrap:wrap; }
        .abf-radio-card { display:flex; align-items:center; gap:8px; padding:11px 16px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:10px; cursor:pointer; font-size:13px; font-weight:600; color:#475569; transition:all .15s; flex:1; min-width:130px; }
        .abf-radio-card input[type="radio"] { accent-color:#2563eb; width:15px; height:15px; flex-shrink:0; }
        .abf-radio-card--active { background:#eff6ff; border-color:#bfdbfe; color:#1d4ed8; }

        .abf-csv-label-row { display:flex; align-items:center; justify-content:space-between; gap:8px; }
        .abf-download-link { display:inline-flex; align-items:center; gap:5px; font-size:12px; font-weight:600; color:#2563eb; text-decoration:none; transition:color .15s; }
        .abf-download-link:hover { color:#1d4ed8; }

        /* Dropzone */
        .abf-dropzone { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:20px; border:2px dashed #e2e8f0; border-radius:12px; cursor:pointer; min-height:90px; transition:all .2s; }
        .abf-dropzone--active:hover { border-color:#93c5fd; background:#f0f9ff; }
        .abf-dropzone--disabled { background:#f8fafc; opacity:.6; cursor:not-allowed; }
        .abf-dropzone-file { display:flex; align-items:center; gap:8px; }
        .abf-dropzone-filename { font-size:13px; font-weight:600; color:#0f172a; max-width:220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
        .abf-dropzone-remove { display:flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background:#fee2e2; border:none; color:#dc2626; cursor:pointer; flex-shrink:0; }
        .abf-dropzone-placeholder { display:flex; flex-direction:column; align-items:center; }
        .abf-dropzone-label { font-size:13px; color:#475569; font-weight:600; }
        .abf-dropzone-hint { font-size:11.5px; color:#94a3b8; margin-top:2px; }

        /* Summary */
        .abf-loading { display:flex; align-items:center; gap:10px; padding:12px 16px; background:#f8fafc; border-radius:12px; border:1px solid #e2e8f0; }
        .abf-spinner { width:18px; height:18px; border:2px solid #e2e8f0; border-top-color:#2563eb; border-radius:50%; animation:abfSpin .65s linear infinite; flex-shrink:0; }
        @keyframes abfSpin { to{transform:rotate(360deg)} }
        .abf-loading-txt { font-size:12.5px; color:#64748b; font-weight:500; }

        .abf-summary { display:flex; flex-direction:column; gap:12px; }
        .abf-summary-main { background:#fff; border:1.5px solid #e2e8f0; border-radius:13px; padding:16px; display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap; }
        .abf-summary-key { font-size:11.5px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:.4px; margin-bottom:5px; }
        .abf-summary-val { font-size:22px; font-weight:800; color:#0f172a; line-height:1.1; }
        .abf-summary-currency { font-size:13px; font-weight:600; color:#64748b; }
        .abf-summary-fees { display:flex; flex-direction:column; gap:6px; align-self:flex-end; }
        .abf-fee-row { display:flex; justify-content:space-between; gap:16px; font-size:12px; color:#64748b; font-weight:500; }
        .abf-fee-val { font-weight:700; color:#334155; }
        .abf-summary-grid { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
        .abf-summary-card { background:#fff; border:1.5px solid #e2e8f0; border-radius:11px; padding:12px 14px; }
        .abf-summary-card--green { border-color:#bbf7d0; background:linear-gradient(135deg,#f0fdf4,#dcfce7); }
        .abf-summary-card--blue  { border-color:#bfdbfe; background:linear-gradient(135deg,#eff6ff,#dbeafe); }
        .abf-summary-card-label { font-size:11px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.4px; margin-bottom:5px; }
        .abf-summary-card-val { font-size:18px; font-weight:800; color:#0f172a; line-height:1.1; }
        .abf-summary-card-val span { font-size:12px; font-weight:600; color:#64748b; }
        .abf-summary-card--green .abf-summary-card-val { color:#15803d; }
        .abf-summary-card--blue  .abf-summary-card-val { color:#1d4ed8; }

        .abf-error-banner { display:flex; align-items:flex-start; gap:10px; background:linear-gradient(135deg,#fff1f2,#ffe4e6); border:1.5px solid #fecaca; border-radius:11px; padding:12px 14px; font-size:12.5px; color:#b91c1c; font-weight:500; line-height:1.5; }
        .abf-error-banner svg { flex-shrink:0; margin-top:1px; color:#dc2626; }

        /* Footer */
        .abf-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px; flex-shrink:0; }
        .abf-footer-note { display:flex; align-items:center; gap:5px; font-size:12px; color:#94a3b8; font-weight:500; }
        .abf-footer-btns { display:flex; align-items:center; gap:8px; }
        .abf-btn-cancel { font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:9px 16px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .abf-btn-cancel:hover { background:#f1f5f9; }
        .abf-btn-submit { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:700; color:#fff; padding:10px 20px; border-radius:10px; border:none; background:linear-gradient(135deg,#1d4ed8,#2563eb); cursor:pointer; box-shadow:0 4px 14px rgba(37,99,235,.3); transition:transform .15s, box-shadow .18s; }
        .abf-btn-submit:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 8px 24px rgba(37,99,235,.38); }
        .abf-btn-submit:disabled { opacity:.5; cursor:not-allowed; transform:none; box-shadow:none; }
        .abf-btn-spinner { display:inline-block; width:15px; height:15px; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; border-radius:50%; animation:abfSpin .65s linear infinite; }

        @media (max-width:540px) { .abf-panel { max-width:100%; } .abf-header, .abf-body, .abf-footer { padding-left:18px; padding-right:18px; } }
      `}</style>
    </>
  );
};

export default AddBatchFile;